import { useState } from 'react';
import { Input } from '@comeon/ui';
import Icon, { ICON_INFO } from '~/components/icon/index.js';

import { LOADING } from '../utils/constants.js';
import { creditCard } from '../../deposit/data/validate.js';
import { InfoText, StyledCVVInput, PaymentButtonSecondary } from '../utils/qd-styled-utils.js';

const QDCVVscreen = ({ translation: t, views, executeQDDeposit }) => {
	const [cvv, setCVV] = useState('');
	const [info, toggleInfo] = useState(false);
	const setCVVandExecute = () => {
		executeQDDeposit({ cvv });
	};
	return (
		<>
			<StyledCVVInput className="quick-deposit-cvv-wrapper">
				<Input
					type="tel"
					autoFocus
					id="CVVInput"
					className="button u-mb2"
					onChange={e => setCVV(e.target?.value)}
					value={cvv}
					data-map="phone"
					automationClass=""
					label={t.QD_CVV_INPUT}
					disabled={views.includes(LOADING)}
				/>
				<button onClick={() => toggleInfo(!info)}>
					<Icon type={ICON_INFO} className="collapse__info-icon" />
				</button>
				{info ? <InfoText>{t.QD_CVV_INFO}</InfoText> : null}
			</StyledCVVInput>
			<PaymentButtonSecondary
				smallfont
				disabled={!creditCard.cc.isAccepted(cvv) || views.includes(LOADING)}
				onClick={setCVVandExecute}
				type="submit"
				className="button u-mb1 u-mt1"
				title="title"
				dataAt="mobile-quick-deposit-button"
			>
				{t.QD_CVV_CONTINUE}
			</PaymentButtonSecondary>
		</>
	);
};

export default QDCVVscreen;
